var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"c",staticClass:"viz",class:_vm.stateClass})
}
var staticRenderFns = []

export { render, staticRenderFns }